


























































































import {Component, Vue} from 'vue-property-decorator';
import {Stored} from 'vue-stored-prop-decorator';
import {Game, Player} from '@/models';
import gameStore from '@/stores/modules/game';
import playerStore from '@/stores/modules/player';
import manager from '@/Manager';
import saver from '@/Saver';

@Component
export default class Start extends Vue {
	
	@Stored(playerStore)
	public players: Player[];
	
	@Stored(gameStore)
	public game: Game;
	
	public newGameConfirm: boolean = false;
	
	public mounted(): void {
		this.game.matchs[0].expend = true;
	}
	
	public newGame(): void {
		manager.clear();
		gameStore.commit('reset');
		saver.saveCurrent();
		this.$router.push({ name: 'home' });
	}
	
}

